<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"/>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.positionTypeId" clearable filterable placeholder="请选择职位类型">
            <el-option
              v-for="item in positionTypesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="请选择状态" @change="list">
            <el-option label="正常" value="0"/>
            <el-option label="待审核" value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search"> 查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd"> 新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" label="id" width="100"/>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime * 1000 | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="positionTypeId" label="职位类型">
          <template slot-scope="scope">
            {{ positionTypesMap[scope.row.positionTypeId] }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称"/>
        <el-table-column prop="cn" label="中文"/>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{ {0: "正常", 1: "删除", 2: "待审核"}[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-dropdown size="mini" trigger="hover" placement="bottom" @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right"/>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ cmd: 'edit', row: scope.row }">
                  编辑
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', row: scope.row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="新增职位">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
        <el-form-item label="职位类型" prop="positionTypeId">
          <el-select v-model="addForm.positionTypeId" clearable filterable placeholder="请选择职位类型">
            <el-option
              v-for="item in positionTypesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name"/>
        </el-form-item>
        <el-form-item label="中文" prop="cn">
          <el-input v-model="addForm.cn"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="addForm.status" clearable placeholder="请选择状态" @change="list">
            <el-option label="正常" value="0"/>
            <el-option label="待审核" value="2"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false"> 取消</el-button>
        <el-button :loading="addLoading" type="primary" @click.native="addSubmit"> 提交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
        <el-form-item label="职位类型" prop="positionTypeId">
          <el-select v-model="editForm.positionTypeId" clearable filterable placeholder="请选择职位类型">
            <el-option
              v-for="item in positionTypesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"/>
        </el-form-item>
        <el-form-item label="中文" prop="cn">
          <el-input v-model="editForm.cn"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option :value="0" label="正常" />
            <el-option :value="2" label="待审核" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false"> 取消</el-button>
        <el-button :loading="editLoading" type="primary" @click.native="editSubmit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "Position",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editFormRules: {},
      editLoading: false,
      positionTypesList: [],
      positionTypesMap: {},
    };
  },
  mounted() {
    mainHeight(this);
    this.getPositionType();
    this.list();
  },
  methods: {
    search() {
      this.page.page = 1;
      this.list();
    },
    getPositionType() {
      const me = this;
      const params = Object.assign({
        page: 1,
        limit: 1000000000,
      });
      this.axios
        .get("/api/admin/position-type/list", params)
        .then((data) => {
          this.positionTypesList = data.results;
          for (var i = 0; i < data.results.length; i++) {
            this.positionTypesMap[data.results[i].id] = data.results[i].name;
          }
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("/api/admin/position/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.addForm = {
        chinese: "",
        english: "",
      };
      this.addFormVisible = true;
    },
    addSubmit() {
      const me = this;
      this.axios
        .form("/api/admin/position/create", this.addForm)
        .then((data) => {
          me.$message({message: "提交成功", type: "success"});
          me.addFormVisible = false;
          me.list();
        })
        .catch((rsp) => {
          me.$notify.error({title: "错误", message: rsp.message});
        });
    },
    handleEdit(row) {
      const me = this;
      this.axios
        .get(`/api/admin/position/${row.id}`)
        .then((data) => {
          me.editForm = Object.assign({}, data);
          me.editFormVisible = true;
        })
        .catch((rsp) => {
          me.$notify.error({title: "错误", message: rsp.message});
        });
    },
    editSubmit() {
      const params = {...this.editForm};
      const me = this;
      this.axios
        .form("/api/admin/position/update", params)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$notify.error({title: "错误", message: rsp.message});
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    deleteSubmit(row) {
      const me = this;
      this.$confirm("是否删除职位?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          me.axios
            .form("/api/admin/position/delete", {id: row.id})
            .then(function () {
              me.$message({message: "删除成功", type: "success"});
              me.list();
            })
            .catch(function (err) {
              me.$notify.error({title: "错误", message: err.message || err});
            });
        })
        .catch(function () {
          me.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCommand(cmd) {
      if (cmd.cmd === "edit") {
        this.handleEdit(cmd.row);
      } else if (cmd.cmd === "delete") {
        this.deleteSubmit(cmd.row);
      }
    },
  },
};
</script>

<style scoped></style>
